export default "__VITE_ASSET__DeWCe8WM__"